<template>
  <tr class="structure-tree">
    <td class="structure-user">
      {{ user }}
    </td>
    <td class="structure-child">
      <table width="100%">
        <tbody>
        <PrintList
            v-for="child in children"
            :children="child.children"
            :user="child.user"
        >
        </PrintList>
        </tbody>
      </table>
    </td>
  </tr>
</template>

<script>

export default {
  name: "PrintList",
  props: ['user', 'children'],
}
</script>

<style>
.structure-tree {
  border: solid 1px;
}

.structure-user {
  border: none;
}

.structure-child {
}

.structure-tree .structure-child {
  padding: 0;
}

.structure-tree td {
  padding: 1%;
}

.structure-child table {
  margin: 10px 10px 10px 0 !important;
}
</style>


// WEBPACK FOOTER //
// StructurePrintList.vue?597917b7